import LayerSettings from '../../../../models/layer-settings';

export interface LayerSettingsHandler {
  getInstance: () => LayerSettings;
  updateInstance: (newLayerSettings: LayerSettings) => void;
  registerListener: (event: string, listener: () => void) => void;
  onUpdate: (listener: () => void) => void;
  destroy: () => void;
}

interface RegisteredListener {
  event: string;
  listener: () => void;
}

const LayerSettingsReferenceHandler = (initialLayerSettings: LayerSettings): LayerSettingsHandler => {
  let layerSettings: LayerSettings = initialLayerSettings;
  const registeredListeners: RegisteredListener[] = [];
  const updateListeners: (() => void)[] = [];

  const updateInstance = (newLayerSettings: LayerSettings) => {
    if (newLayerSettings === layerSettings) {
      return;
    }

    registeredListeners.forEach(({ event, listener }) => {
      layerSettings.off(event, listener);
      newLayerSettings.on(event, listener);
    });
    layerSettings = newLayerSettings;
    updateListeners.forEach((listener) => listener());
  };

  return {
    getInstance: () => layerSettings,
    updateInstance,
    registerListener: (event: string, listener: () => void) => {
      registeredListeners.push({ event, listener });
      layerSettings.on(event, listener);
    },
    onUpdate: (listener: () => void) => {
      updateListeners.push(listener);
    },
    destroy: () => {
      registeredListeners.forEach(({ event, listener }) => layerSettings.off(event, listener));
    },
  };
};

export default LayerSettingsReferenceHandler;
